/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Search } from "@mui/icons-material";
import {
  Button,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { VendorListArray } from "../../../@types/DRO/GetAllVendorsResponse";
import { GetAllVendorsListApi } from "../../../api/GetVendorsList/GetAllVendorsListApi";
import { useLoading } from "../../../views/Loader/LoadingContext";
import SideBarNavigation from "../../Layouts/Sidebar/Sidebar";
import VendorTableComponent from "../../Layouts/Table/VendorTableComponent";

type EnabledFilter = "enabled" | "disabled";

const VendorListPage = () => {
  const { id } = useParams();
  const columns = ["id", "name", "email", "tax", "enabled"];
  const columnHeaders = [
    "Vendor ID",
    "Vendor Name",
    "Vendor Email",
    "Vendor Tax",
    "Status",
  ];
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [enabledFilter, setEnabledFilter] = useState<EnabledFilter>("enabled");
  const [totalPages, setTotalPages] = useState(1);
  const [vendorData, setVendorData] = useState<VendorListArray[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebouncedSearchQuery(searchQuery.trim());
    }, 350);

    return () => window.clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setLoading(true);
    const fetchVendorData = async () => {
      try {
        const response = await GetAllVendorsListApi.api.getAllVendorsList(
          page,
          rowsPerPage,
          debouncedSearchQuery,
          undefined,
          undefined,
          enabledFilter === "enabled"
        );
        setVendorData(response.data.data);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error("Error fetching vendor data", error);
      }
      setLoading(false);
    };

    fetchVendorData();
  }, [page, rowsPerPage, debouncedSearchQuery, enabledFilter, refreshKey]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const handleEnabledFilterChange = (e: SelectChangeEvent) => {
    setEnabledFilter(e.target.value as EnabledFilter);
    setPage(0);
  };

  const handleVendorDisabled = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="flex h-screen">
      <div className="w-1/6 bg-white shadow-md">
        <SideBarNavigation />
      </div>
      <div className="flex-1 p-6 ml-8 bg-[#F8FAFC]">
        <h1 className="text-3xl font-semibold mb-6 text-left">
          Vendor Details
        </h1>
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center space-x-4">
            <TextField
              placeholder="Search vendor by name or email"
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              sx={{
                width: 300,
                bgcolor: "white",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#e5e7eb",
                  },
                  "&:hover fieldset": {
                    borderColor: "#d1d5db",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#3b82f6",
                  },
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search sx={{ color: "#9ca3af" }} />
                  </InputAdornment>
                ),
              }}
            />
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-500 font-medium">Status :</span>
              <Select
                size="small"
                value={enabledFilter}
                onChange={handleEnabledFilterChange}
                sx={{ minWidth: 100, bgcolor: "white", fontSize: 14 }}>
                <MenuItem value="enabled">Active</MenuItem>
                <MenuItem value="disabled">Inactive</MenuItem>
              </Select>
            </div>
          </div>
          <Button
            variant="contained"
            onClick={() => navigate("/create/vendor")}
            sx={{
              textTransform: "none",
              bgcolor: "#171F21",
              "&:hover": { bgcolor: "#0077F" },
              fontSize: "16px",
              borderRadius: "30px",
              px: 3,
              py: 1,
            }}>
            Add Vendor
          </Button>
        </div>
        <div>
          <VendorTableComponent
            columns={columns}
            columnHeaders={columnHeaders}
            data={vendorData}
            setSelectedOrder={() => {}}
            currentPage={page}
            setCurrentPage={setPage}
            totalPages={totalPages}
            onVendorDisabled={handleVendorDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default VendorListPage;
